import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { SiteLogo } from "@/components/SiteLogo";
import { AlertCircle, Home } from "lucide-react";
import { useLocation } from "wouter";
import { SITE_NAME } from "@shared/site";

export default function NotFound() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    const prev = document.title;
    document.title = `Page not found — ${SITE_NAME}`;
    return () => {
      document.title = prev;
    };
  }, []);

  const handleGoHome = () => {
    setLocation("/");
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background p-6 gap-8">
      <SiteLogo className="h-10 text-foreground" />
      <Card className="w-full max-w-lg border-border/50 bg-card/95 backdrop-blur-sm">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-red-500/15 rounded-full animate-pulse" />
              <AlertCircle className="relative h-16 w-16 text-red-500" />
            </div>
          </div>

          <h1 className="text-4xl font-bold text-foreground mb-2">404</h1>

          <h2 className="text-xl font-semibold text-muted-foreground mb-4">
            Page Not Found
          </h2>

          <p className="text-muted-foreground mb-8 leading-relaxed">
            Sorry, the page you are looking for does not exist.
            <br />
            It may have been moved or deleted.
          </p>

          <div
            id="not-found-button-group"
            className="flex flex-col sm:flex-row gap-3 justify-center"
          >
            <Button
              onClick={handleGoHome}
              className="font-bold text-black px-6 py-2.5 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg"
              style={{ background: "var(--pb-green)" }}
            >
              <Home className="w-4 h-4 mr-2" />
              Back to {SITE_NAME}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
